import { render } from "./ManualShipmentModal.vue?vue&type=template&id=6eb583bd&scoped=true&ts=true&lang=pug"
import script from "./ManualShipmentModal.vue?vue&type=script&lang=ts"
export * from "./ManualShipmentModal.vue?vue&type=script&lang=ts"

import "./ManualShipmentModal.vue?vue&type=style&index=0&id=6eb583bd&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6eb583bd"]])

export default __exports__